import { Box, Link as MuiLink, Typography } from '@mui/material';

import { FULL_TIME_TERMS_URL } from '@app/utils/constants';

// TODO:テーマにトークンを追加して置き換える(現状はデザイン指定のハードコード)
const NOTICE_BG_COLOR = '#FFE1E1';
const NOTICE_TEXT_COLOR = '#FF0000';

export interface FullTimeFeeNoticeProps {
  /** 'banner':一覧画面上部の警告帯 / 'plain':ダイアログ内の本文 */
  variant?: 'banner' | 'plain';
}

/**
 * 常勤求人の採用成功報酬フィーについての注意文。
 * 掲載管理一覧(ProductManagement)と同意モーダル(FullTimeProductCreation)で
 * 同一文言を表示するため共通化している。
 */
export function FullTimeFeeNotice({
  variant = 'plain',
}: FullTimeFeeNoticeProps) {
  const text = (
    <Typography variant="body2" component="span" color="inherit">
      ProDoctorsで常勤求人を掲載・応募・採用された場合には、採用医師の年収に応じた採用成功報酬の費用を請求させていただきます。
      <br />
      {'御理解・ご了承の上ご利用ください。　費用の詳細については'}
      <MuiLink
        href={FULL_TIME_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        // NOTE:親のcolor(赤)がcascadeするため!importantで明示的に上書きする
        sx={{ color: '#00E !important' }}
      >
        利用規約
      </MuiLink>
      をご確認ください。
    </Typography>
  );

  if (variant === 'plain') {
    return text;
  }

  return (
    <Box
      sx={{
        bgcolor: NOTICE_BG_COLOR,
        borderRadius: '10px',
        color: NOTICE_TEXT_COLOR,
        mb: 2,
        px: 2,
        py: 1,
      }}
    >
      {text}
    </Box>
  );
}
